// DS9.5
import React from 'react';
import c from 'classnames';
import Button from '../Buttons/GhostButton';
import SolidButton from '../Buttons/SolidButton';
import s from './InfoBlock.scss';
const InfoBlock = ({ className, titleClassName, subtitleClassName, withIllustrationBelow, title, subtitle, illustration, illustrationClassName, withButton, buttonLabel, buttonAlignment = 'horizontal', buttonVariant, backgroundType = 'solid', customButton, customSecondaryButton, height, onButtonClick, biData })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], s[`background-${backgroundType}`], height && s['with-fixed-height'], className),
        style: {
            height
        }
    }, illustration && /*#__PURE__*/ React.createElement("div", {
        className: c(s['illustration'], withIllustrationBelow && s['illustration-below'], illustrationClassName)
    }, illustration), /*#__PURE__*/ React.createElement("div", {
        className: c(s['title'], titleClassName)
    }, title), /*#__PURE__*/ React.createElement("div", {
        className: c(s['subtitle'], subtitleClassName)
    }, subtitle), /*#__PURE__*/ React.createElement("div", {
        className: c(s['buttons'], /* eslint-disable eqeqeq */ buttonAlignment == 'vertical' && s['buttons-vertical'])
    }, customSecondaryButton, customButton || withButton && (buttonVariant ? /*#__PURE__*/ React.createElement(SolidButton, {
        variant: buttonVariant,
        size: "medium",
        onClick: onButtonClick,
        biData: biData
    }, buttonLabel) : /*#__PURE__*/ React.createElement(Button, {
        variant: "main",
        size: "medium",
        onClick: onButtonClick,
        biData: biData
    }, buttonLabel))));
};
InfoBlock.displayName = 'InfoBlock';
export default InfoBlock;
